import { isProduction } from "@portal/app/_common/lib/edgeUtils";

/** Mixpanel collects in production only; MIXPANEL_DEBUG opts another environment in. */
export const isMixpanelEnvironment = () => isProduction() || !!process.env.MIXPANEL_DEBUG;

/** Shared Mixpanel policy; explicit admin events still obey geography/environment settings. */
export const isTrackableVisitor = ({
  activeRole,
  country,
  allowAdmin = false,
}: {
  activeRole?: string;
  country?: string;
  allowAdmin?: boolean;
}) =>
  (activeRole !== "ADMIN" || allowAdmin) &&
  (!country || country === "US") &&
  isMixpanelEnvironment();
